import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import CyberSecurity from "../Utiilities/CyberSecurity";
import DemoButtons from "../Utiilities/DemoButtons";
import LMS_Slider from "../Utiilities/LMS_Slider";
import TMS_Slider from "../Utiilities/TMS_Slider";
function OverviewCommonTMS365(props) {
  const videoUrl = "https://youtu.be/AcJ9d1S6Ong";
  const [isLightboxOpen, setLightboxOpen] = React.useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = React.useState('');
  const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
  const closeLightbox = () => {
    setLightboxOpen(false);
  };
  const getEmbedUrl = (url) => {
    if (url.includes('youtube.com/watch?v=')) {
      return url.replace('watch?v=', 'embed/');
    } else if (url.includes('youtu.be/')) {
      const videoId = url.split('youtu.be/')[1];
      return `https://www.youtube.com/embed/${videoId}`;
    } else if (url.includes('vimeo.com/')) {
      const videoId = url.split('vimeo.com/')[1];
      return `https://player.vimeo.com/video/${videoId}`;
    } else {
      return url; // fallback for direct video links
    }
  };
  const handlePlayClick = () => {
    setIsVideoPlaying(true); // When play icon is clicked, play the video
  };
  const handleCloseVideo = () => {
    setIsVideoPlaying(false); // Close the video
  };
  return (
    <>
      <div style={{ background: "none" }} className="overviewsection ETOverViewSection" >
        <h2 className="HR_heading" style={{ marginBottom: "0vw", color: "#333" }}>Manage All Your Tasks in One Place With Task 365</h2>
        <p style={{ margin: "0" }}>Managing tasks across multiple platforms wastes time and slows execution. Important work gets buried, ownership becomes unclear, and teams lose momentum searching for information.
        </p>
        <p style={{ margin: "0" }}>Task 365 streamlines task planning and tracking within Microsoft 365, keeping tasks, timelines, and ownership visible inside Teams, SharePoint, and Outlook.
        </p>
        <p style={{ margin: "0" }}>The result: faster execution, clear ownership, fewer follow-ups, and consistent delivery every time.
        </p>

        <div style={{ margin: "1vw 0vw", display: "flex", justifyContent: "center", marginBottom: "1vw" }}>
          <DemoButtons LMS365="LMS365" demobtnText="Explore Task 365" />
        </div>
        <div>
          <TMS_Slider />
        </div>


      </div>

    </>
  );
}

export default OverviewCommonTMS365;
